import { RAFFLE_EVENTS, RAFFLE_DATA_SOURCE } from '@/packages/components/hook/useRaffle'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-raffle', // 组件名
  type: 'component-business', // 组件类型
  label: '翻牌抽奖', // 组件label
  icon: 'icon-xy-clip-raffle', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 750 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  element: {
    type: Object,
    default: () => ({
      // 组件名称
      name: '',
      // 组件类型
      type: '',
      // 组件id
      uuid: '',
      // 隐藏
      hiden: false,
      // 动画
      animations: [],
      // 组件样式
      style: {},
      // 组件数据
      data: {},
      // 多语言
      languages: [],
      // 数据源
      dataSource: null,
      // 事件
      events: []
    })
  },
  cols: { type: Number, default: 5 },
  verticalGutter: { type: Number, default: 10 }, // 垂直间距
  horizontalGutter: { type: Number, default: 10 }, // 水平间距
  width: { type: Number, default: 600 }, // 宽度
  height: { type: Number, default: 500 }, // 高度
  cardWidth: { type: Number, default: 120 }, // 卡牌宽度
  cardHeight: { type: Number, default: 180 }, // 卡牌高度
  cardText: { type: String, default: '翻' }, // 卡牌背面文字
  cardTextColor: { type: String, default: '#fff' }, // 卡牌背面文字颜色
  cardBorderRadius: { type: Number, default: 20 }, // 卡牌圆角
  cardBackgroundColor: { type: String, default: '#bac5ee' }, // 卡牌背景颜色
  cardBackgroundSrc: { type: String, default: '' }, // 卡牌背景图片
  cardActiveBackgroundColor: { type: String, default: '' }, // 卡牌选中背景颜色
  cardActiveBackgroundSrc: { type: String, default: '' }, // 卡牌选中背景图片
  // 活动配置
  activityId: { type: String, default: '' }, // 活动id
  prizes: { type: Array, default: [] }, // 奖品列表
  prizeImages: { type: Object, default: {} }, // 奖品图片
  customDialogUUID: { type: String, default: '' }, // 抽中大奖后展示的自定义弹窗节点（为空则弹默认确认框）
  isNewVersion: { type: Boolean, default: false }, // 是否是新版本
  isHideChangeBigRewardConfirmPopup: { type: Boolean, default: false }, // 是否隐藏切换大奖确认弹窗
  isAutoSelectBigReward: { type: Boolean, default: false }, // 是否自动选择大奖
  resetRewardData: { type: Boolean, default: true } // 是否重置翻牌记录
}

/**
 * 组件开放方法事件
 */
export const events = RAFFLE_EVENTS

/**
 * 组件开放数据源
 */
export const dataSource = RAFFLE_DATA_SOURCE

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-raffle'
  },
  {
    type: 'xy-form-input',
    label: '卡牌背文字',
    propKey: 'cardText',
    isLanguage: true
  },
  {
    type: 'xy-form-upload-image',
    label: '卡牌背景图', // 表单名称
    propKey: 'cardBackgroundSrc', // 表单model字段名称
    isLanguage: true // 是否可多语言配置
  }
]
